<template>
  <div class="studioone-widget text-center">
    <select :value="nodeId" class="form-control form-control-sm mb-2" @change="onNodeChange">
      <option value="">-- Node --</option>
      <option v-for="n in nodes" :key="n.id" :value="n.id">{{ n.name }}</option>
    </select>
    <div class="btn-group">
      <button class="btn btn-success" :disabled="!nodeId" @click="cmd('play')"><i class="fas fa-play"></i></button>
      <button class="btn btn-danger" :disabled="!nodeId" @click="cmd('stop')"><i class="fas fa-stop"></i></button>
      <button class="btn btn-warning" :disabled="!nodeId" @click="cmd('record')"><i class="fas fa-circle"></i></button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    config: { type: Object, default: () => ({}) },
    widgetId: { type: String, default: '' },
  },
  computed: {
    ...mapGetters('mission', ['nodes']),
    nodeId() {
      return this.config.nodeId || ''
    },
  },
  methods: {
    ...mapActions('mission', ['sendCommand']),
    ...mapActions('workspace', ['updateWidgetConfig']),
    onNodeChange(e) {
      if (!this.widgetId) return
      this.updateWidgetConfig({ widgetId: this.widgetId, config: { nodeId: e.target.value } })
    },
    async cmd(action) {
      await this.sendCommand({ node_id: this.nodeId, adapter: 'studioone', action, payload: {} })
    },
  },
}
</script>

<style scoped>
.studioone-widget {
  color: var(--ws-text);
}
</style>
